export function isTrustedHost() {
  return window.location.hostname === 'lemonadefashion.com' ||
    window.location.hostname === 'joinpipp.com' ||
    window.location.hostname.endsWith('.lemonadefashion.com') ||
    window.location.hostname.endsWith('.joinpipp.com');
}
